import { MatPaginatorIntl } from '@angular/material/paginator';

export class MyCustomPaginatorIntl extends MatPaginatorIntl {
  constructor() {
    super();
    // copy super.getRangeLabel reference before overriding it
    const superGetRangeLabel = this.getRangeLabel;
    this.getRangeLabel = (page: number, pageSize: number, length: number) => {
      const label = superGetRangeLabel(page, pageSize, length);
      // if length is max safe integer, it is a placeholder for unknown length. replace it with unknown
      return length === Number.MAX_SAFE_INTEGER
        ? label.replace(`of ${length}`, `of unknown`)
        : label;
    };
  }
}
